import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {profileComparisonSectionCardSx} from './profileComparisonSectionStyles';
import {ProfileComparisonSelectionTraySlot} from './ProfileComparisonSelectionTraySlot';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {profileComparisonSelection} from '../../../../../layouts/theme/designSystem';
import type {CompanyWorkforceProfile} from '../../types/WorkforceProfileTypes';

export interface Props {
  profileA: CompanyWorkforceProfile | null;
  profileB: CompanyWorkforceProfile | null;
  onDeselectA: () => void;
  onDeselectB: () => void;
}

export const ProfileComparisonSelectionTray = ({profileA, profileB, onDeselectA, onDeselectB}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceDepartmentHealthPage.profileComparison.tray'});

  return (
    <EmpionPaper sx={profileComparisonSectionCardSx} data-testid='profile-comparison-selection-tray'>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap'}}>
        <Typography sx={{fontSize: '12px', fontWeight: 600, color: 'text.secondary', whiteSpace: 'nowrap'}}>
          {t('label')}
        </Typography>
        <ProfileComparisonSelectionTraySlot
          label={t('slotA')}
          profile={profileA}
          colors={profileComparisonSelection.slotA}
          onDeselect={onDeselectA}
        />
        <Typography sx={{fontSize: '12px', color: 'text.secondary', opacity: 0.85}}>{t('versus')}</Typography>
        <ProfileComparisonSelectionTraySlot
          label={t('slotB')}
          profile={profileB}
          colors={profileComparisonSelection.slotB}
          onDeselect={onDeselectB}
        />
      </Box>
    </EmpionPaper>
  );
};
